



















































































import { Button } from "mint-ui";
import { Component, Emit } from "vue-property-decorator";
import { Appoint } from "../middleware/Appoint";
import { AppointSelectProp } from "../types/components/Appoint";
import CheckBox from "./checkbox/index.vue";
import squareDialog from '@/components/dialog/square/index';
import qs from "qs";

@Component<VAPPOINT>({
  components: {
    "mt-button": Button,
    checkbox: CheckBox,
  },
})
export default class VAPPOINT extends Appoint {
  public provinceCode: string = "";
  public checked: boolean = true;
  public cityCode: string = "";
  public storeCode: string = "";
  public carType: string = "RDX";
  public userName: string = "";
  public userPhone: string = "";
  public sex: number = 1;
  public defaultSelect: AppointSelectProp = { name: "请选择", value: "" };
  public provinceList: AppointSelectProp[] = [
    { name: "请选择省份", value: "" },
  ];
  public cityList: AppointSelectProp[] = [{ name: "请选择城市", value: "" }];
  public storeList: AppointSelectProp[] = [{ name: "请选择经销商", value: "" }];
  public seriesId: string = "h5";
  public carTypeList: any[] = [
    {
      label: "红旗H5",
      value: "H5",
    },
  ];
  public created() {
    this.initProvinceList();
    this.weChatInputBug();
  }

  @Emit("submitAppointCallback")
  public submitAppointCallback() {}

  public isWeiXinAndIos() {
    const ua = `${window.navigator.userAgent.toLowerCase()}`;
    const isWeixin = /MicroMessenger/i.test(ua);
    const isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
    return isWeixin && isIos;
  }

  public weChatInputBug() {
    // 解决微信键盘收起页面不回弹的问题
    let myFunction: any;
    const isWXAndIos = this.isWeiXinAndIos();
    if (isWXAndIos) {
      document.body.addEventListener("focusin", () => {
        clearTimeout(myFunction);
      });
      document.body.addEventListener("focusout", () => {
        clearTimeout(myFunction);
        myFunction = setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }, 200);
      });
    }
  }

  public verifyForm() {
    console.log(this.storeCode);
    return new Promise((resolve:any) => {
      var reg = /^1\d{10}$/gi;
      let dialog = this.$dialog as any;
      if (!this.checked) {
        dialog.alert({
          message: "请勾选个人信息保护声明",
        });
        return;
      }
      if (this.userName == "") {
        dialog.alert({
          message: "请输入姓名",
        });
      } else if (this.userPhone == "") {
        dialog.alert({
          message: "请输入手机号",
        });
      } else if (!reg.test(this.userPhone)) {
        dialog.alert({
          message: "请输入正确的手机号",
        });
      } else if (!this.seriesId) {
        dialog.alert({
          message: "请选择意向车型",
        });
      } else if (!this.provinceCode) {
        dialog.alert({
          message: "请选择省份",
        });
      } else if (!this.cityCode) {
        dialog.alert({
          message: "请选择城市",
        });
      } else if (!this.storeCode) {
        dialog.alert({
          message: "请选择经销商",
        });
      } else {
        resolve();
      }
    });
  }

  public changeProvince(e: any) {
    this.cityCode = "";
    this.storeCode = "";
    this.provinceCode = e.target.value;
    this.initCityList(this.provinceCode);
  }
  public changeCity(e: any) {
    this.storeCode = "";
    this.cityCode = e.target.value;
    this.initStoreList(this.provinceCode, this.cityCode);
  }
  public changeStore(e: any) {
    console.log(e.target.value);
    this.storeCode = e.target.value;
  }
  public async initProvinceList() {
    let provinceList = await this.getProvinces();
    provinceList.forEach((item: any, index: number) => {
      this.provinceList.push({
        name: item,
        value: item,
      });
    });
  }
  public async initCityList(provinceCode: string) {
    let cityList = await this.getCityies(provinceCode);
    this.cityList = [{ name: "请选择城市", value: "" }];
    cityList.forEach((item: any, index: number) => {
      this.cityList.push({
        name: item,
        value: item,
      });
    });
  }
  public async initStoreList(provinceCode: string, cityCode: string) {
    let storeList = await this.getStoreList(provinceCode, cityCode);
    this.storeList = [{ name: "请选择经销商", value: "" }];
    storeList.forEach((item: any, index: number) => {
      this.storeList.push({
        name: item,
        value: item,
      });
    });
  }
  public submitAppoint() {
    this.verifyForm().then(async () => {
      let params: any = {
        sex: '空',
        //seriesId: this.seriesId,
        carModel:'H5',
        userPhone: this.userPhone,
        userName: this.userName,
        province: this.provinceCode,
        city: this.cityCode,
        dealer: this.storeCode,
      };
      let res = await this.booking(params, (data: any) => {
        squareDialog({
          userPhone:this.userPhone,
          lotteryKey:data.lotteryKey
        })
      });
      window._hmt.push(["_trackPageview", "/#/appoint"]);
    });
  }
}
